
      import { updateViewport } from './src/utils/viewport';
      updateViewport();
      window.addEventListener('popstate', updateViewport);
    